const sectionText = document.querySelector('.section-menu-text')
if (sectionText) {
  const onCurrentLayoutChange = function (newLayout, prevLayout) {
    sectionText.innerHTML = newLayout.title
    var computed = window.getComputedStyle(sectionText)
    sectionText.style.maxWidth = parseFloat(computed.width) + 'px'
  }
  window.addEventListener('cmpb-layout-changed', (event) => {
    onCurrentLayoutChange(event.layout, event.prevLayout)
  })
}



// WEBPACK FOOTER //
// ./src/js/section-menu.js